import React, { useEffect, useState } from 'react';
import { VerificationResponse } from '../../types/VerificationTypes';
import { VerificationService } from '../../services/verificationService';
import VerificationPage from './VerificationPage';
import LoadingSpinner from './LoadingSpinner';
import ErrorPage from './ErrorPage';

interface CredentialVerificationProps {
  credentialId: string;
}

const CredentialVerification: React.FC<CredentialVerificationProps> = ({ credentialId }) => {
  const [verificationData, setVerificationData] = useState<VerificationResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (credentialId) {
      verifyCredential(credentialId);
    }
  }, [credentialId]);

  const verifyCredential = async (id: string) => {
    try {
      setLoading(true);
      setError(null);
      const result = await VerificationService.verifyCredential(id);
      setVerificationData(result);
    } catch (err) {
      setError('Failed to verify credential');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error || !verificationData) {
    return <ErrorPage message={error || 'Verification failed'} />;
  }

  return <VerificationPage data={verificationData} />;
};

export default CredentialVerification; 